import Vue from "vue";
import { Toast } from "mint-ui";
import Global from '@/Global.js';

export default {
    config() {
        return new Promise(function (resolve, reject) {
            Vue.http.get(Global.serverUrl + "/wxmp/signature?url=" + window.location.href)
                .then(function (resp) {
                    if(resp.body.code==200){
                        window.wx.config({
                            debug: false,
                            appId: resp.body.data.appId,
                            timestamp: resp.body.data.timestamp,
                            nonceStr: resp.body.data.noncestr,
                            signature: resp.body.data.signature,
                            jsApiList: ['checkJsApi', 'scanQRCode']
                        });
                        resolve();
                    }else{
                        Toast(resp.body.msg || "操作失败，请稍后再试！");
                        reject();
                    }
                });
        });
    },
    scanQRCode() {
        return new Promise(function (resolve, reject) {
            window.wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    resolve(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
                }
            });
        });
    }
};